export default function PHP_strtok() {
  return (
    <div>
      <h1>PHP_strtok</h1>
    </div>
  );
}
